import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { useState, useEffect, useRef } from "react";
import MDButton from "../../../../components/MDButton";
import DataTable from "../../../../examples/Tables/DataTable";
import Modal from '@mui/material/Modal';
import Autocomplete from "@mui/material/Autocomplete";
import FormField from "../../account/components/FormField";
import MDSnackbar from "../../../../components/MDSnackbar";
import MDInput from "../../../../components/MDInput";
import { modalStyleAds } from "../../../../components/Utils/ModalStyle";
import MDBadge from "../../../../components/MDBadge";
import GHIconButton from "../../../../components/GHIconButton";
import { getAds, createAd, updateAd, deleteAd, uploadAdImage } from "../../../../services/ads.service";
import { getUserRole } from "../../../../services/auth.service";
import MDAvatar from "../../../../components/MDAvatar";
import { getClients } from "../../../../services/clients.service";


const AD_TYPES = [
  { value: "announcement", label: "Building Announcement" },
  { value: "promo", label: "Platform Promotion" },
  { value: "external", label: "External Advertisement" },
];

const AD_STATUSES = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "scheduled", label: "Scheduled" },
];

const TARGET_TYPES = [
  { value: "all", label: "All Clients" },
  { value: "selected", label: "Specific Clients" },
];

function AdsList() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [editingAd, setEditingAd] = useState(null);
  const [formData, setFormData] = useState({
    title: "", content: "", type: "announcement", status: "active",
    image_url: "", link_url: "", link_text: "", priority: 5, dismissible: true,
    target_type: "all", client_ids: [],start_date: null,
    end_date: null,
  });
  const [infoSB, setInfoSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const isSuperAdmin = getUserRole() === "super_admin";
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);

  const loadAds = async () => {
    try {
      setLoading(true);
      const response = await getAds();
      setAds(response.data || []);
    } catch (error) {
      console.error("Error loading ads:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadClients = async () => {
    try {
      const response = await getClients();
      setClients(response.data || []);
    } catch (error) {
      console.error("Error loading clients:", error);
    }
  };

  useEffect(() => { loadAds(); loadClients(); }, []);

  const handleOpen = (ad = null) => {
    if (ad) {
      setEditingAd(ad);
      setFormData({
        title: ad.title || "", content: ad.content || "", type: ad.type || "announcement",
        status: ad.status || "active", image_url: ad.image_url || "", link_url: ad.link_url || "",
        link_text: ad.link_text || "", priority: ad.priority || 5, dismissible: ad.dismissible !== false,
        target_type: ad.target_type || "all", client_ids: (ad.clients || []).map(c => c.id),
        start_date: ad.start_date ? ad.start_date.substring(0,10) : "",
        end_date: ad.end_date ? ad.end_date.substring(0,10) : "",
      });
      setImagePreview(ad.image_url || null);
      setSelectedClients(ad.clients || []);
    } else {
      setEditingAd(null);
      setFormData({
        title: "", content: "", type: "announcement", status: "active",
        image_url: "", link_url: "", link_text: "", priority: 5, dismissible: true,
        target_type: "all", client_ids: [],start_date: new Date().toISOString().split("T")[0],
        end_date: new Date().toISOString().split("T")[0],
      });
      setImagePreview(null);
      setSelectedClients([]);
    }
    setImageFile(null);
    setOpen(true);
  };

  const handleClose = () => { setOpen(false); setEditingAd(null); setImageFile(null); setImagePreview(null); setSelectedClients([]); };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setSnackMessage("Image must be less than 2MB");
        setErrorSB(true);
        return;
      }
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!formData.title) { setSnackMessage("Title is required"); setErrorSB(true); return; }
    try {
      let adId;
      if (editingAd) {
        await updateAd(editingAd.id, formData);
        adId = editingAd.id;
        setSnackMessage("Ad updated successfully");
      } else {
        const response = await createAd(formData);
        adId = response.data.id;
        setSnackMessage("Ad created successfully");
      }

      // Upload image if selected
      if (imageFile && adId) {
        const fd = new FormData();
        fd.append("image", imageFile, imageFile.name);
        fd.append("id", adId);
        try {
          await uploadAdImage(fd);
        } catch (imgError) {
          console.error("Image upload failed:", imgError);
          setSnackMessage("Ad saved but image upload failed");
          setErrorSB(true);
        }
      }

      setInfoSB(true);
      handleClose();
      loadAds();
    } catch (error) {
      setSnackMessage(error.response?.data?.status || "Error saving ad");
      setErrorSB(true);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this ad?")) return;
    try {
      await deleteAd(id);
      setSnackMessage("Ad deleted successfully");
      setInfoSB(true);
      loadAds();
    } catch (error) {
      setSnackMessage("Error deleting ad");
      setErrorSB(true);
    }
  };

  const getTypeBadge = (type) => {
    const colors = { announcement: "info", promo: "warning", external: "success" };
    const labels = { announcement: "Announcement", promo: "Promotion", external: "External" };
    return <MDBadge badgeContent={labels[type] || type} color={colors[type] || "dark"} size="sm" container />;
  };

  const getStatusBadge = (status) => {
    const colors = { active: "success", inactive: "secondary", scheduled: "warning" };
    return <MDBadge badgeContent={status} color={colors[status] || "dark"} size="sm" container />;
  };

  const getTargetBadge = (ad) => {
    if (ad.target_type === "selected" && ad.clients?.length > 0) {
      const names = ad.clients.map(c => c.client_name || c.name).join(", ");
      const display = ad.clients.length > 2 ? `${ad.clients.length} clients` : names;
      return <MDBadge badgeContent={display} color="secondary" size="sm" container />;
    }
    return <MDBadge badgeContent="All Clients" color="light" size="sm" container />;
  };

  const tableData = {
    columns: [
      { Header: "Image", accessor: "image", width: "8%" },
      { Header: "Title", accessor: "title", width: "20%" },
      { Header: "Type", accessor: "type", width: "10%" },
      { Header: "Target", accessor: "target", width: "15%" },
      { Header: "Status", accessor: "status", width: "8%" },
      { Header: "Views", accessor: "views", width: "6%" },
      { Header: "Clicks", accessor: "clicks", width: "6%" },
      { Header: "Actions", accessor: "actions", width: "10%" },
    ],
    rows: ads.map((ad) => ({
      image: ad.image_url ? (
        <MDAvatar src={ad.image_url} alt={ad.title} size="lg" variant="rounded" />
      ) : (
        <MDBox sx={{ width: 48, height: 48, backgroundColor: "#e0e0e0", borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Icon sx={{ color: "#999" }}>image</Icon>
        </MDBox>
      ),
      title: <MDTypography variant="button" fontWeight="medium">{ad.title}</MDTypography>,
      type: getTypeBadge(ad.type),
      target: getTargetBadge(ad),
      status: getStatusBadge(ad.status),
      views: ad.view_count || 0,
      clicks: ad.click_count || 0,
      actions: (
        <MDBox display="flex" gap={1}>
          <GHIconButton title="Edit" color="info" icon="edit" size="small" onClick={() => handleOpen(ad)} />
          <GHIconButton title="Delete" color="error" icon="delete" size="small" onClick={() => handleDelete(ad.id)} />
        </MDBox>
      ),
    })),
  };

  const availableTypes = isSuperAdmin ? AD_TYPES : AD_TYPES.filter(t => t.value === "announcement");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDSnackbar color="success" icon="check" title="Success" content={snackMessage}
          open={infoSB} onClose={() => setInfoSB(false)} close={() => setInfoSB(false)} />
        <MDSnackbar color="error" icon="warning" title="Error" content={snackMessage}
          open={errorSB} onClose={() => setErrorSB(false)} close={() => setErrorSB(false)} />

        <Modal open={open} onClose={handleClose}>
          <MDBox sx={modalStyleAds}>
            <Card sx={{ overflow: "visible", minWidth: 500 }}>
              <MDBox p={3}><MDTypography variant="h5">{editingAd ? "Edit" : "Create"} Ad</MDTypography></MDBox>
              <MDBox component="form" pb={3} px={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormField label="Title *" value={formData.title}
                      onChange={(e) => setFormData({ ...formData, title: e.target.value })} />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput label="Content" multiline rows={3} fullWidth value={formData.content}
                      onChange={(e) => setFormData({ ...formData, content: e.target.value })} />
                  </Grid>
                  <Grid item xs={6}>
                    <Autocomplete options={availableTypes} getOptionLabel={(o) => o.label}
                      value={availableTypes.find(t => t.value === formData.type) || availableTypes[0]}
                      onChange={(e, v) => setFormData({ ...formData, type: v?.value || "announcement" })}
                      renderInput={(params) => <FormField {...params} label="Type" />} />
                  </Grid>
                  <Grid item xs={6}>
                    <Autocomplete options={AD_STATUSES} getOptionLabel={(o) => o.label}
                      value={AD_STATUSES.find(s => s.value === formData.status) || AD_STATUSES[0]}
                      onChange={(e, v) => setFormData({ ...formData, status: v?.value || "active" })}
                      renderInput={(params) => <FormField {...params} label="Status" />} />
                  </Grid>
                  <Grid item xs={6}>
                    <MDInput
                      type="date"
                      label="Start Date"
                      InputLabelProps={{ shrink: true }}
                      value={formData.start_date || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, start_date: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <MDInput
                      type="date"
                      label="End Date"
                      InputLabelProps={{ shrink: true }}
                      value={formData.end_date || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, end_date: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDTypography variant="button" fontWeight="medium" mb={1} display="block">
                      Banner Image (1200×300px, max 2MB)
                    </MDTypography>
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      style={{ display: "none" }}
                      ref={fileInputRef}
                      onChange={handleImageChange}
                    />
                    <MDBox display="flex" alignItems="center" gap={2}>
                      {imagePreview ? (
                        <MDBox
                          component="img"
                          src={imagePreview}
                          alt="Preview"
                          sx={{ width: 200, height: 50, objectFit: "cover", borderRadius: 1, border: "1px solid #ddd" }}
                        />
                      ) : (
                        <MDBox
                          sx={{ width: 200, height: 50, backgroundColor: "#f5f5f5", borderRadius: 1, border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                          <MDTypography variant="caption" color="secondary">No image</MDTypography>
                        </MDBox>
                      )}
                      <MDButton color="secondary" size="small" onClick={() => fileInputRef.current?.click()}>
                        <Icon sx={{ mr: 0.5 }}>upload</Icon> {imagePreview ? "Change" : "Upload"}
                      </MDButton>
                      {imagePreview && (
                        <MDButton color="error" size="small" variant="outlined" onClick={() => { setImageFile(null); setImagePreview(null); }}>
                          <Icon>close</Icon>
                        </MDButton>
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      options={TARGET_TYPES}
                      getOptionLabel={(o) => o.label}
                      value={TARGET_TYPES.find(t => t.value === formData.target_type) || TARGET_TYPES[0]}
                      onChange={(e, v) => {
                        const newType = v?.value || "all";
                        setFormData({ ...formData, target_type: newType, client_ids: newType === "all" ? [] : formData.client_ids });
                        if (newType === "all") setSelectedClients([]);
                      }}
                      renderInput={(params) => <FormField {...params} label="Target Audience" />}
                    />
                  </Grid>
                  {formData.target_type === "selected" && (
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        options={clients}
                        getOptionLabel={(o) => o.client_name || o.name || `Client ${o.id}`}
                        value={selectedClients}
                        onChange={(e, v) => {
                          setSelectedClients(v);
                          setFormData({ ...formData, client_ids: v.map(c => c.id) });
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderInput={(params) => <FormField {...params} label="Select Clients" />}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <MDBox
                              key={option.id}
                              component="span"
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                backgroundColor: '#e3f2fd',
                                borderRadius: '16px',
                                padding: '2px 10px',
                                margin: '2px',
                                fontSize: '0.875rem',
                              }}
                              {...getTagProps({ index })}
                            >
                              {option.client_name || option.name}
                            </MDBox>
                          ))
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={8}>
                    <FormField label="Link URL" value={formData.link_url}
                      onChange={(e) => setFormData({ ...formData, link_url: e.target.value })} />
                  </Grid>
                  <Grid item xs={4}>
                    <FormField label="Link Text" value={formData.link_text}
                      onChange={(e) => setFormData({ ...formData, link_text: e.target.value })} />
                  </Grid>
                  <Grid item xs={12}>
                    <MDButton color="info" size="large" fullWidth onClick={handleSave}>
                      {editingAd ? "Update" : "Create"} Ad
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Modal>

        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <MDTypography variant="h4">Ads & Announcements</MDTypography>
          <MDButton variant="gradient" color="info" size="large" onClick={() => handleOpen()}>
            <Icon sx={{ mr: 1 }}>add</Icon> New Ad
          </MDButton>
        </MDBox>
        <Card>
          {loading ? (
            <MDBox p={3} textAlign="center"><MDTypography>Loading...</MDTypography></MDBox>
          ) : (
            <DataTable table={tableData} entriesPerPage={{ defaultValue: 10 }} canSearch />
          )}
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AdsList;
